import { Pipe, PipeTransform, } from '@angular/core';
// import { first } from 'rxjs/operators';
import moment from 'moment-timezone';

@Pipe({ name: 'sort' })
export class Sort implements PipeTransform {
    transform(data, key, order, fromOrSortType?): any {

        if (!key) { return data; }

        if (data.length > 0) {
            // tslint:disable-next-line: prefer-const
            let orderBy = data[0]['sort'] ? data[0]['sort'] : order, tempKey;
            const isFilter = fromOrSortType === 'filter';
            const sortType = isFilter ? undefined : fromOrSortType;
            if (isFilter) {
                tempKey = 'value';
            } else {
                tempKey = key;
            }
            console.log('typeof data[0][key]  ', typeof data[0][tempKey] );
            if (isFilter && key === 'date') {

                data.sort((a, b) => {
                    const data1 = Number(moment(a[tempKey]).format('X'));
                    const data2 = Number(moment(b[tempKey]).format('X'));
                    if (orderBy === 'desc') {
                        return data2 - data1;
                    } else {
                        return data1 - data2;
                    }

                });
            } else if (sortType === 'number' || typeof data[0][tempKey] === 'number') {
                data.sort((a, b) => {
                    const data1 = Number(a[tempKey] ?? 0);
                    const data2 = Number(b[tempKey] ?? 0);
                    if (orderBy === 'desc') {
                        return data2 - data1;
                    } else {
                        return data1 - data2;
                    }
                });
            } else if (typeof data[0][tempKey] === 'string') {
                data.sort((a, b) => {
                    const data1 = (a[tempKey] ?? '').toString().replace(/\s/g, '').toLowerCase();
                    const data2 = (b[tempKey] ?? '').toString().replace(/\s/g, '').toLowerCase();
                    if (orderBy === 'desc') {
                        if (data2 < data1) {
                            return -1;
                          }
                          if (data2 > data1) {
                            return 1;
                          }
                          return 0;
                    } else {
                        if (data1 < data2) {
                            return -1;
                          }
                          if (data1 > data2) {
                            return 1;
                          }
                          return 0;
                    }

                });
            }
        }



    return data;
    }
}
